import { jsx as _jsx } from "react/jsx-runtime";
import { isNil } from "lodash-es";
import { useCallback, useContext, useMemo } from "react";
import { USelectContext, USelectProviders } from "./context/context";
import { USelectGeneralComponent } from "./UltraSelect";
const Component = ({ value: _value, onChange: _onChange, onCreate: _onCreate, ...props }) => {
    const { immediatelySetSearch, setShowDropdown } = useContext(USelectContext);
    const value = useMemo(() => {
        return !isNil(_value) ? [_value] : null;
    }, [_value]);
    const onChange = useCallback((value, event) => {
        setShowDropdown(false);
        const lastOption = value[value.length - 1];
        const currentValue = typeof _value === "string" || typeof _value === "number" ? _value : _value?.value;
        if (lastOption?.value !== currentValue) {
            immediatelySetSearch("");
            return _onChange?.(lastOption, event);
        }
    }, [_onChange, _value, immediatelySetSearch, setShowDropdown]);
    const onCreate = useCallback((value) => {
        setShowDropdown(false);
        return _onCreate?.(value);
    }, [_onCreate, setShowDropdown]);
    return (_jsx(USelectGeneralComponent, { ...props, value: value, onChange: onChange, onCreate: _onCreate ? onCreate : undefined }));
};
export const UltraSelectSingle = (props) => {
    return (_jsx(USelectProviders, { onSearch: props.onSearch, onDropdownHidden: props.onDropdownHidden, onDropdownShow: props.onDropdownShow, children: _jsx(Component, { removeSelected: false, ...props }) }));
};
